
import { useContext } from 'react'
import { useForm, Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import { FormControl, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import { Button } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import useUpdateUser from '../../hooks/useUpdateUser'
import useUserById from '../../hooks/useGetUserById'
import CircularProgress from '@mui/material/CircularProgress'
import { contextApp } from '../../../../context/appContext'

const ModalUserEdit = ({ openModal, onClose, idDoc, idRealation }) => {
    const { loadingData } = useContext(contextApp)
    const { control, handleSubmit, reset, formState: { errors } } = useForm()
    const { roles, userStates } = useUserById(idRealation, openModal, reset)
    const { update } = useUpdateUser(onClose)

    const edit = (data) => {
        const objRol = roles.find(rol => rol.name === data.rol)
        const objState = userStates.find(state => state.name === data.userState)
        const dataUpdate = {
            idDoc,
            nombreUsuario: data.name,
            rolUsuario: {
                state: objRol.name,
                label: objRol.label,
            },
            estado: {
                state: objState.name,
                label: objState.label,
            },
        }

        update(dataUpdate)
    }

    return (
        <Dialog open={openModal} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Actualizar Usuario</DialogTitle>
            <form onSubmit={handleSubmit(edit)} >
                <DialogContent>
                    <Stack spacing={2}>
                        <Controller
                            name="name"
                            control={control}
                            defaultValue=''
                            rules={{ required: "Username is required" }}
                            render={({ field }) => <TextField
                                label="Nombre"
                                fullWidth
                                {...field}
                                helperText={errors.name ? errors.name.message : null}
                                error={errors.name ? true : false}
                            />}
                        />
                        <Controller
                            name="rol"
                            control={control}
                            defaultValue=''
                            render={({ field }) => <FormControl>
                                <InputLabel id="demo-simple-select-label">Rol</InputLabel>
                                <Select
                                    labelId="rol"
                                    id="rol"
                                    value=''
                                    label="Rol"
                                    {...field}
                                >
                                    {
                                        roles.map((rol) =>
                                            <MenuItem value={rol.name} key={rol.id}>{rol.label}</MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>}
                        />
                        <Controller
                            name="userState"
                            control={control}
                            defaultValue=''
                            render={({ field }) => <FormControl>
                                <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                                <Select
                                    labelId="userState"
                                    id="userState"
                                    value=''
                                    label="Rol Usuario"
                                    {...field}
                                >
                                    {
                                        userStates.map((state) =>
                                            <MenuItem value={state.name} key={state.id}>{state.label}</MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>}
                        />

                    </Stack>

                </DialogContent>
                <DialogActions>
                    <Button type='submit' variant="contained" color="success" disabled={loadingData}>
                        {loadingData && <CircularProgress size={20} sx={{ marginRight: '10px', color: '#FFF' }} />}
                        actualizar
                    </Button>
                    <Button onClick={onClose} variant="contained" color="error" disabled={loadingData}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog >
    )
}

export default ModalUserEdit